<template>
	<b-modal ref="profile_modal"
			 size="lg"
			 bodyClass="p-0"
			 v-bind:no-close-on-backdrop=true
			 :hide-header=true
			 v-model="is_show_modal"
			 :dialogClass=dialog_class_draw>

		<template v-slot:modal-header="{ close }">
			<!-- Emulate built in modal header close button action -->
			<b-button size="sm" variant="outline-danger" @click="close()">
				Close Modal
			</b-button>
		</template>

		<!-- BODY -->
		<div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
			<div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
				<h2 >
					<span class="fw-300">ID:{{this.city.uniq_id}}</span>
				</h2>
				<div class="panel-toolbar pr-3 pb-2 align-self-end">
					<button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
						<i class="fal fa-times"></i>
					</button>
				</div>
			</div>

			<div class="panel-container show">

				<b-overlay :show="is_load" rounded="sm">


					<div class="panel-content">
						<div class="d-flex flex-column align-items-center justify-content-center p-4">
							<h5 class="mb-0 fw-700 text-center mt-3">
								{{this.city.title}}
								<small class="text-muted mb-0">
									{{__t('city_info')}}
								</small>
							</h5>
						</div>

						<div>
							<b-tabs content-class="mt-3" v-if="is_city_loaded">
								<b-tab v-for="(tab,index) in tabs" @click="set_active(index)" :title="get_tab_title(tab)" :key="index" :active="tab.is_active">
									<template slot="title">
										{{get_tab_title(tab)}}
										<b-spinner type="grow" small v-if="tab.is_load"></b-spinner>
									</template>
									<component v-bind:is="tab.index" :city="city"></component>
								</b-tab>
							</b-tabs>
						</div>
						<div>
						</div>
					</div>

				</b-overlay>
			</div>
			<!--FOOTER -->
		</div>

		<template v-slot:modal-footer="{close}">
			<div class="modal-footer">
				<button type="button" @click="remove(false)" class="btn btn-outline-danger waves-effect waves-themed mr-5 pl-5 pr-5" v-if="city_id > 0">
					{{ __t('REMOVE') }}
				</button>


				<button type="button" @click="close()" class="btn btn-secondary waves-effect waves-themed">
					{{ __t('CLOSE') }}
				</button>

				<button type="button" v-on:click="save_city" class="btn btn-primary waves-effect waves-themed">
					{{ __t('SAVE') }}
				</button>
			</div>
		</template>
	</b-modal>
</template>

<script>
import city_info from "./tabs/city_info";
import city_settings from "./tabs/city_settings";

export default {
	components : {
		city_settings,
		city_info
	},
	name: "city_modal",
	props : {
		modal_position : {
			type : String,
			default : "right"
		},
	},
	data() {
		return {
			city_id : 0,
			city: {
				"id" : 0,
				"title" : "",
				"uniq_id" : ""
			},
            is_city_loaded : false,
			is_load: false,
			is_show_modal: false,
			tabs : [
                {
                    "title": "Main Info",
                    "index": "city_info",
                    "is_active" : true,
                },
                {
                    "title": "Item Settings",
                    "index": "city_settings",
                    "is_active" : false,
                }
            ]
		}
	},

	created () {
		EventBus.$on("city_edit",res => this.work_click(res));
		EventBus.$on("close_city",this.close);
	},

	methods : {
		work_click(city_id) {
			this.city_id = city_id;
			this.is_show_modal = true;
			this.load_city();
		},

		get_tab_title (tab) {
			if(tab.count > 0) {
				return tab.title;
			}
			return tab.title;
		},

		set_active (obj) {
			for (let tab in this.tabs) {
				this.tabs[tab].is_active = false;
			}

			this.tabs[obj].is_active = true;
			EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
		},

		async remove(is_force) {
			let self = this;
			const is_ok = confirm_me(this.__t("ARE_SURE"));
			is_ok.then(res => {
				self.is_load = true;
				api.delete('/internal/v1/catalog/cities/'+ parseInt(this.city.id)).then(({data}) => {
					self.is_load = false;
					if (data.status === "operation_success") {
						window.location.reload();
					}
				}).catch(({response}) => {
					self.is_load = false;
					EventBus.$emit('show_toast', {
						err: response.data.message, type: "danger",
						title: response.data.status,
						position : "b-toaster-top-left"
					})
				});
			});
		},

		save_city() {
			EventBus.$emit("save_city_called");
		},

		close () {
			this.city = {
				id : 0,
				title : "",
				uniq_id : "",
			};

			this.is_show_modal = false;
		},

		async load_city () {
			this.is_load = true;
            this.is_city_loaded = false;

			await api.get('/internal/v1/catalog/cities/' + parseInt(this.city_id)).then(({data}) => {
				this.is_load = false;
                this.is_city_loaded = true;
				if (data.status === "operation_success") {
					this.city = {...this.city, ...data.data} ;
				}
			}).catch(({response}) => {
				this.is_load = false;
                this.is_city_loaded = true;
				EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,position : "b-toaster-top-left"})
			});
		}
	},

	computed : {
		dialog_class_draw () {
			if(this.modal_position === "left") {
				return "modal-dialog-left modal-lg";
			}

			return "modal-dialog-right modal-lg";
		},
	}
}
</script>

<style scoped>

</style>
